export const matterConstant = {
    CREATE_MATTER_REQUEST:"CREATE_MATTER_REQUEST",
    CREATE_MATTER_SUCCESS:"CREATE_MATTER_SUCCESS",
    CREATE_MATTER_FAILURE:"CREATE_MATTER_FAILURE",

    GET_MATTER_REQUEST: "GET_MATTER_REQUEST",
    GET_MATTER_SUCCESS: "GET_MATTER_SUCCESS",
    GET_MATTER_FAILURE: "GET_MATTER_FAILURE",
}